import axios from 'axios';
import { ElMessage } from 'element-plus';
import router from '@/router'; // 导入 Vue Router 实例

// 创建 axios 实例
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: process.env.VUE_APP_DEFAULT_TIMEOUT,
});

// 请求拦截器
apiClient.interceptors.request.use(
  config => {
    // 如果请求接口是登录接口，则跳过 token 过期检查
    if (config.url && config.url.includes('/login')) {
      return config;
    }
    
    // 检查 token 是否过期
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    const tokenExpiration = userInfo ? userInfo.tokenExpiration : null;
    if (tokenExpiration && new Date().getTime() > tokenExpiration) {
      localStorage.removeItem('userInfo');
      router.push('/');
      return Promise.reject(new Error('登录已过期，请重新登录'));
    }

    // 在请求发送之前做一些处理，比如添加 token
    const token = userInfo ? userInfo.token : null;
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    // 处理请求错误
    return Promise.reject(error);
  }
);

// 响应拦截器
apiClient.interceptors.response.use(
  response => {
    // 处理响应数据
    if (response.config.fullResponse) {
      return response;
    }
    return response.data;
  },
  error => {
    // 处理响应错误
    if (error.response) {
      console.log('error.response:', error.response);
      const { status } = error.response;
      if (status === 403) {
        ElMessage.error('无权限访问，正在跳转...');
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const role = userInfo ? userInfo.role : null;
        if (role === 'Administrator') {
          router.push('/admin-login');
        } else if (role === 'Evaluator') {
          router.push('/evaluator-login');
        } else if (role === 'Supervisor') {
          router.push('/supervisor-login');
        } else {
          router.push('/');
        }
        router.push('/403');  // 假设你有个 403.vue 页面
      } else {
        ElMessage.error('请求失败, 错误码：' + status);
      }
    } else {
      ElMessage.error('请求失败');
    }
    return Promise.reject(error);
  }
);

const api = {

  // 其他 API 方法...
};

export default api;
